import { SVGProps } from 'react';

export const IconCheckFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g>
      <path fill='#fff' d='M0 0h16v16H0z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm3.574-9.518a.75.75 0 1 0-1.148-.964L6.768 9.872 5.546 8.576a.75.75 0 1 0-1.092 1.03l1.8 1.909a.75.75 0 0 0 1.12-.033l4.2-5Z'
        fill='#0F9654'
      />
    </g>
  </svg>
);
